module.exports = __webpack_public_path__ + "media/old_images/icon-add-to-list-58d354c5.svg";